import {Injectable} from '@angular/core';
import {StandardType} from '../models/standard-type.model';
import {Http} from '@angular/http';
import {ApiConnectService} from './api-connect.service';
import {Response} from '@angular/http';
import {StepsControllerService} from './steps-controller.service';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class StandardTypesService {
  // Список всех типов. Заполняется и меняется из компонентов.
  typesList: any[] = [];
  tempTypesList: any = [];
  // Текущий выбранный тип. Изменяется из компонентов.
  selectedType: any;

  tmpStn: any;

  constructor(private http: HttpClient,
              private apiURL: ApiConnectService,
              private stepsControllerService: StepsControllerService) {
  }

  // Для получения списка типов с сервера и обновления листа typesList.
  updateAllTypes() {
    this.http.get(this.apiURL.getAllTypes, {observe: 'response'}).subscribe(
      (response) => {
        if (response.status === 200) {
          this.tempTypesList = [];
          this.tempTypesList = response.body;
        } else if (response.status === 204) {
          this.typesList = [];
        }
      },
      () => {
      },
      () => {
        this.typesList = [];
        this.typesList = this.tempTypesList;

        if (this.stepsControllerService.getCurrentStandard()) {
          this.tmpStn = this.stepsControllerService.getCurrentStandard();
          if (this.tmpStn['standardType']) {
            this.selectedType = this.tmpStn.standardType;
            this.setSelectedType(this.selectedType);
          }
        } else {
          if (this.typesList.length > 0) {
            this.selectedType = this.typesList[0];
          }
        }

      }
    );
  }

  getAllTypes() {
    return this.http.get(this.apiURL.getAllTypes, {observe: 'response'});
  }

  addNewType(newType) {
    return this.http.post(this.apiURL.createStandardType, newType, {observe: 'response'});
  }

  editType(newType) {
    return this.http.put(this.apiURL.editStandardType, newType, {observe: 'response'});
  }

  setSelectedType(type) {
    this.selectedType = type;
  }

  getSelectedType() {
    return this.selectedType;
  }

  setTypesList(typesList) {
    this.typesList = typesList;
    this.setSelectedType(typesList[0]);
  }

  getTypesList() {
    return this.typesList;
  }

  getTypesForGroup(groupID) {
    return this.http.get(this.apiURL.getTypesForGroup + groupID, {observe: 'response'});
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/standard-types.service.ts